<script setup lang="ts">
import PostPage from '~/pages/post/[slug].vue'
import StandalonePage from '~/pages/page/[slug].vue'
import CategoryPage from '~/pages/category/[...directory].vue'
import { resolveCategoryPath, resolvePagePath, resolvePostPath } from '~/composables/usePermalink'

const route = useRoute()
const siteData = await useSiteData()
const { isStaleNavigation } = useNavigationStaleGuard()
const fields = siteData?.setting?.customFields

const postMatched = computed(() => !!resolvePostPath(fields, route.path))
const pageMatched = computed(() => !!resolvePagePath(fields, route.path))
const categoryMatched = computed(() => !!resolveCategoryPath(fields, route.path))

const currentComponent = computed(() => {
  if (postMatched.value) {
    return PostPage
  }
  if (categoryMatched.value) {
    return CategoryPage
  }
  if (pageMatched.value) {
    return StandalonePage
  }
  return null
})

if (!currentComponent.value && !isStaleNavigation()) {
  if (import.meta.server) {
    throw createError({ status: 404, message: '页面不存在' })
  }
  showError({ statusCode: 404, message: '页面不存在' })
}
</script>

<template>
  <component :is="currentComponent" v-if="currentComponent" />
</template>
